﻿export class AddressCodeData {
    countryCode: string = "";
    provinceCode: string = "";
    districtCode: string = "";
}